import React, { useContext, useState, useEffect } from "react";
import { ref, get, child, set, onValue } from "firebase/database";
import { database } from "../firebaseConfig";
import { AuthContext } from "../AuthContext";
import packageOne from "../assets/packageOne.png";
import packageThree from "../assets/packageThree.jpg";
import packageTwo from "../assets/packageTwo.jpg";
import { useNavigate, useLocation } from "react-router-dom";

const StoreLayout = () => {
  const { currentUser } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();
  const { excludeShine } = location.state || {};
  const [hideDiv, setHideDiv] = useState(true);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [isDemo, setIsDemo] = useState(false);
  const [productName, setProductName] = useState("EcomElevate-subscribe-Purchase");
  const [amount, setCheckoutTotal] = useState(160);
  const [UserEmail, setUserEmail] = useState("support@ecomlevate.com");
  const [DemoActive, setDemoActive] = useState("");
  const [modalContent, setModalContent] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [exchangeRates, setExchangeRates] = useState({ ZAR: 1 }); // Default to ZAR
  const [country, setCountry] = useState("ZAR"); // Default to ZAR
  const [payFastview, setpayFastview] = useState("");

  useEffect(() => {
    fetchGeolocationAndRates();
  }, []);

  const fetchGeolocationAndRates = async () => {
    try {
      const ipapiResponse = await fetch("https://ipapi.co/json/");
      if (!ipapiResponse.ok) {
        throw new Error("Failed to fetch geolocation data");
      }
      const ipapiData = await ipapiResponse.json();
      const currencyCode = ipapiData.currency || "ZAR"; // Fallback to ZAR
      setCountry(currencyCode);
      const ratesResponse = await fetch(
        `https://api.exchangerate-api.com/v4/latest/${currencyCode}`
      );
      if (!ratesResponse.ok) {
        throw new Error("Failed to fetch exchange rates");
      }
      const ratesData = await ratesResponse.json();
      setExchangeRates(ratesData.rates);
    } catch (error) {
      console.error("Error fetching data:", error);
      setCountry("ZAR"); // Fallback to ZAR on error
      setExchangeRates({ ZAR: 1 }); // Ensure ZAR prices display
    }
  };

  const convertPrice = (price, currency) => {
    const parsedPrice = parseFloat(price);
    if (exchangeRates[currency]) {
      return (parsedPrice * exchangeRates[currency]).toFixed(2);
    }
    return parsedPrice;
  };

  const packages = {
    batteryAndSolar: [
      {
        title: "Flash Plus",
        description: "Get one page Ecommerce/online store.",
        price: "200",
        subtitle: "10 items to upload",
        hours: "custom free domain | free hosting",
        componets: [
          "No reviews for each product/item",
          "No cart for the store",
          "Start uploading your items in your store today",
        ],
        appliances: [
          "No reviews for each product",
          "Ready ecommerce store today",
          "Your own store name in words",
        ],
        backgroundImages: [packageOne],
      },
      {
        title: "Spark",
        description:
          "Ecommerce/online store. Search functionality will make it effortless for customers to find what they're looking for.",
        price: "350",
        subtitle: "30 items to upload",
        hours: "custom free domain | free hosting",
        componets: [
          "20 reviews for each product/item",
          "No cart for the store",
          "Start uploading your items in your store today",
        ],
        appliances: [
          "20 reviews for each product\n",
          "Ready ecommerce store\n",
          "Your own logo",
        ],
        backgroundImages: [packageOne],
      },
      {
        title: "Glow",
        description:
          "Ecommerce/online store. Clear categories, search functionality and cart will make it effortless for customers to find what they're looking for.",
        price: "500",
        subtitle: "Unlimited items to upload",
        hours: "custom free domain | free hosting",
        appliances: [
          "unlimited reviews\n",
          "designed ecommerce store\n",
          "Your own logo",
        ],
        backgroundImages: [packageThree, packageThree],
      },
      {
        title: "Shine",
        description:
          "Unlock Your Dream Store: Any Design, Your Perfect Online Store, Custom-Made for You!",
        price: "1000",
        subtitle: "Unlimited items to upload",
        hours: "custom free domain | free hosting",
        compo: ["Start Creating Your Perfect Online Store Today!"],
        comp: "Custom features",
        appliances: [
          "Full custom store/ecommerce\n",
          "Your own free Domain name. Free hosting\n",
          "unlimited reviews for each product\n",
        ],
        backgroundImages: [packageOne, packageTwo],
      },
    ],
  };

  const filteredPackages = excludeShine
    ? packages.batteryAndSolar.filter((pkg) => pkg.title !== "Shine")
    : packages.batteryAndSolar;

  const [currentImageIndices, setCurrentImageIndices] = useState(
    Array(filteredPackages.length).fill(0)
  );

  useEffect(() => {
    const intervals = filteredPackages.map((pkg, pkgIndex) => {
      return setInterval(() => {
        setCurrentImageIndices((prevIndices) => {
          const newIndices = [...prevIndices];
          const imagesLength = filteredPackages[pkgIndex].backgroundImages.length;
          newIndices[pkgIndex] =
            newIndices[pkgIndex] === imagesLength - 1
              ? 0
              : newIndices[pkgIndex] + 1;
          return newIndices;
        });
      }, Math.random() * 5000 + 8000);
    });

    return () => intervals.forEach(clearInterval);
  }, [filteredPackages]);

  useEffect(() => {
    const checkSelectedPackage = async () => {
      try {
        const userId = currentUser.uid;
        const snapshot = await get(
          child(ref(database), `users/${userId}/selectedPackage`)
        );
        if (snapshot.exists()) {
          const selectedPkg = snapshot.val().package;
          setSelectedPackage(selectedPkg);
        }
      } catch (error) {
        console.error("Error fetching selected package from Firebase:", error);
      }
    };

    if (currentUser) {
      checkSelectedPackage();
    }
  }, [currentUser]);

  const handleOpenModal = (pkg, demo) => {
    setModalContent(pkg);
    setModalVisible(true);
  };

  useEffect(() => {
    if (modalContent && modalVisible) {
      const currency = country;
      const convertedPrice = convertPrice(modalContent.price, currency);
      setCheckoutTotal(parseFloat(convertedPrice));
    }
  }, [modalContent, modalVisible, exchangeRates, country]);

  const subscribe = async () => {
    setModalVisible(false);
    setHideDiv(false);
    try {
      const response = await fetch(
        "https://domain-checker-api-git-main-givens-projects-48cf6823.vercel.app/initiate-subscription",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            productName,
            amount,
            UserEmail,
          }),
        }
      );

      if (response.ok) {
        const paymentData = await response.json();
        setpayFastview(paymentData.paymentId.uuid);
      } else {
        throw new Error("Failed to initiate payment");
      }
    } catch (error) {
      console.error("Error initiating payment:", error);
    }
  };

  useEffect(() => {
    if (payFastview) {
      const existingViewportMetaTags = document.head.querySelectorAll(
        'meta[name="viewport"]'
      );
      existingViewportMetaTags.forEach((tag) => tag.remove());

      const payFastMeta = document.createElement("meta");
      payFastMeta.name = "viewport";
      payFastMeta.content = "width=device-width, initial-scale=1.0";
      document.head.appendChild(payFastMeta);

      const payFastContainer = document.createElement("div");
      payFastContainer.style.zIndex = "999";
      document.body.appendChild(payFastContainer);

      const script = document.createElement("script");
      script.src = "https://www.payfast.co.za/onsite/engine.js";
      script.async = true;
      script.onload = () => {
        if (window.payfast_do_onsite_payment) {
          window.payfast_do_onsite_payment({ uuid: payFastview }, (result) => {
            if (result === true) {
              handleSelectPackage(selectedPackage, isDemo);
            }
          });
        } else {
          console.error("PayFast script did not load correctly.");
        }
      };
      script.onerror = () => {
        console.error("Failed to load PayFast script.");
      };
      document.body.appendChild(script);

      return () => {
        document.body.removeChild(script);
        document.body.removeChild(payFastContainer);
        document.head.removeChild(payFastMeta);
      };
    }
  }, [payFastview]);

  const handleSelectPackage = (pkg, demo) => {
    setSelectedPackage(pkg);
    setIsDemo(demo);

    const userId = currentUser.uid;
    set(ref(database, `users/${userId}/selectedPackage`), {
      package: pkg,
      isDemo: false,
    })
      .then(() => {
        navigate("/home");
      })
      .catch((error) => {
        console.error("Error saving selected package:", error);
      });
  };

  const DemoSelectPackage = (pkg, demo) => {
    setSelectedPackage(pkg);
    setIsDemo(demo);

    const userId = currentUser.uid;
    set(ref(database, `users/${userId}/selectedPackage`), {
      package: pkg,
      isDemo: true,
    })
      .then(() => {
        navigate("/home");
      })
      .catch((error) => {
        console.error("Error saving selected package:", error);
      });
  };

  useEffect(() => {
    if (currentUser) {
      const userId = currentUser.uid;
      const userRef = ref(database, `users/${userId}/selectedPackage`);

      const fetchUserData = async () => {
        try {
          onValue(userRef, (snapshot) => {
            const userData = snapshot.val();
            if (userData) {
              setDemoActive(userData.isDemo);
            }
          });
        } catch (error) {
          console.error("Error fetching user data:", error);
        }
      };

      fetchUserData();
    }
  }, [currentUser]);

  const sortedPackages = [...filteredPackages].sort(
    (a, b) => parseFloat(a.price) - parseFloat(b.price)
  );

  const currencySymbols = {
    AED: "د.إ",
    AFN: "؋",
    ALL: "L",
    AMD: "֏",
    ANG: "ƒ",
    AOA: "Kz",
    ARS: "$",
    AUD: "A$",
    AWG: "ƒ",
    AZN: "₼",
    BAM: "KM",
    BBD: "Bds$",
    BDT: "৳",
    BGN: "лв",
    BHD: ".د.ب",
    BIF: "FBu",
    BMD: "$",
    BND: "B$",
    BOB: "Bs.",
    BRL: "R$",
    BSD: "$",
    BTN: "Nu.",
    BWP: "P",
    BYN: "Br",
    BZD: "$",
    CAD: "C$",
    CDF: "FC",
    CHF: "CHF",
    CLP: "$",
    CNY: "¥",
    COP: "$",
    CRC: "₡",
    CUP: "$MN",
    CVE: "$",
    CZK: "Kč",
    DJF: "Fdj",
    DKK: "kr",
    DOP: "RD$",
    DZD: "د.ج",
    EGP: "£",
    ERN: "Nfk",
    ETB: "Br",
    EUR: "€",
    FJD: "FJ$",
    FKP: "£",
    FOK: "kr",
    GBP: "£",
    GEL: "₾",
    GGP: "£",
    GHS: "GH₵",
    GIP: "£",
    GMD: "D",
    GNF: "FG",
    GTQ: "Q",
    GYD: "$",
    HKD: "HK$",
    HNL: "L",
    HRK: "kn",
    HTG: "G",
    HUF: "Ft",
    IDR: "Rp",
    ILS: "₪",
    IMP: "£",
    INR: "₹",
    IQD: "ع.د",
    IRR: "﷼",
    ISK: "kr",
    JEP: "£",
    JMD: "J$",
    JOD: "د.ا",
    JPY: "¥",
    KES: "KSh",
    KGS: "лв",
    KHR: "៛",
    KID: "$",
    KMF: "CF",
    KRW: "₩",
    KWD: "د.ك",
    KYD: "$",
    KZT: "₸",
    LAK: "₭",
    LBP: "ل.ل",
    LKR: "Rs",
    LRD: "$",
    LSL: "M",
    LYD: "ل.د",
    MAD: "د.م.",
    MDL: "L",
    MGA: "Ar",
    MKD: "ден",
    MMK: "K",
    MNT: "₮",
    MOP: "P",
    MRU: "UM",
    MUR: "₨",
    MVR: "Rf",
    MWK: "MK",
    MXN: "Mex$",
    MYR: "RM",
    MZN: "MT",
    NAD: "$",
    NGN: "₦",
    NIO: "C$",
    NOK: "kr",
    NPR: "₨",
    NZD: "NZ$",
    OMR: "ر.ع.",
    PAB: "B/.",
    PEN: "S/",
    PGK: "K",
    PHP: "₱",
    PKR: "₨",
    PLN: "zł",
    PYG: "₲",
    QAR: "ر.ق",
    RON: "lei",
    RSD: "din",
    RUB: "₽",
    RWF: "FRw",
    SAR: "﷼",
    SBD: "SI$",
    SCR: "₨",
    SDG: "ج.س.",
    SEK: "kr",
    SGD: "S$",
    SHP: "£",
    SLL: "Le",
    SOS: "Sh",
    SRD: "$",
    SSP: "£",
    STN: "Db",
    SYP: "£S",
    SZL: "L",
    THB: "฿",
    TJS: "ЅМ",
    TMT: "T",
    TND: "د.ت",
    TOP: "T$",
    TRY: "₺",
    TTD: "TT$",
    TVD: "$",
    TWD: "NT$",
    TZS: "TSh",
    UAH: "₴",
    UGX: "USh",
    USD: "$",
    UYU: "$U",
    UZS: "so'm",
    VES: "Bs.",
    VND: "₫",
    VUV: "VT",
    WST: "WS$",
    XAF: "FCFA",
    XCD: "$",
    XOF: "CFA",
    XPF: "₣",
    YER: "﷼",
    ZAR: "R",
    ZMW: "ZK",
    ZWL: "$",
  };

  return (
    <div className="container-fluid py-5">
      <style>
        {`
          .list-numbered {
            list-style-type: decimal;
            margin-bottom: 1rem;
          }
          .list-numbered li {
            margin-bottom: 1rem;
          }
        `}
      </style>
      {hideDiv && (
        <>
          <div className="sticky-top bg-white py-3">
            <div className="text-center mb-5">
              <h1 className="display-4 fw-bold">Choose Your Package</h1>
              <p className="lead text-dark">
                Select the best package for your store and start your journey today.
              </p>
            </div>
          </div>
          <div className="row d-flex align-items-stretch">
            {sortedPackages.map((pkg, index) => (
              <div
                className="col-md-6 col-lg-4 mb-4 d-flex rounded"
                key={index}
              >
                <div
                  className="card h-100 border-0 shadow-sm flex-fill position-relative"
                  style={{
                    backgroundImage: `url(${
                      pkg.backgroundImages[currentImageIndices[index]]
                    })`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                  }}
                >
                  <div className="overlay"></div>
                  <div className="card-body d-flex flex-column position-relative">
                    <h1 className="card-title w-100 text-center text-light">
                      {pkg.title}
                    </h1>
                    <p className="card-text text-light lead">
                      {pkg.description}
                    </p>
                    <h6 className="fw-bold text-uppercase text-light">What you get</h6>
                    <ol className="list-numbered text-light">
                      {pkg.appliances.map((appliance, index) => (
                        <li key={index}>{appliance}</li>
                      ))}
                    </ol>
                    <h5 className="card-text text-light text-uppercase">
                      {pkg.comp || pkg.hours}
                    </h5>
                    <h1 className="card-text text-light">
                      <div>
                        {currencySymbols[country] || "R"} {convertPrice(pkg.price, country)} <small>p/m</small>
                      </div>
                    </h1>
                    <hr />
                    <div className="mt-auto d-flex justify-content-between mt-3">
                      <button
                        className="btn btn-primary w-100 text-uppercase fw-bold"
                        onClick={() => handleOpenModal(pkg, false)}
                      >
                        Select Package
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          {modalVisible && (
            <div className="modal d-block" tabIndex="-1" role="dialog">
              <div className="modal-dialog modal-fullscreen">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title text-center w-100 text-uppercase">
                      {modalContent.title}
                    </h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={() => setModalVisible(false)}
                    ></button>
                  </div>
                  <div className="modal-body w-100 text-center">
                    <img
                      src={
                        modalContent.backgroundImages[
                          currentImageIndices[
                            filteredPackages.findIndex(
                              (pkg) => pkg.title === modalContent.title
                            )
                          ]
                        ]
                      }
                      alt={modalContent.title}
                      className="img-fluid mb-3"
                    />
                    <p className="lead">{modalContent.description}</p>
                    <h4 className="fw-bold">{modalContent.comp || modalContent.hours}</h4>
                    <h1 className="fw-bold">
                      <div>
                        {currencySymbols[country] || "R"} {convertPrice(modalContent.price, country)} <small>p/m</small>
                      </div>
                    </h1>
                    <p className="lead">{modalContent.subtitle}</p>
                    <h6 className="fw-bold text-uppercase">What you get</h6>
                    <ol className="list-numbered">
                      {modalContent.appliances.map((appliance, index) => (
                        <li key={index} className="text-start text-center">
                          {appliance}
                        </li>
                      ))}
                    </ol>
                  </div>
                  <div className="modal-footer d-flex justify-content-center">
                    <button
                      onClick={subscribe}
                      className="btn btn-success rounded me-2 flex-grow-1 h-5"
                    >
                      Pay Now
                    </button>
                    {!DemoActive && (
                      <button
                        onClick={() => DemoSelectPackage(modalContent, true)}
                        className="btn btn-secondary rounded ms-2 flex-grow-1 h-5"
                      >
                        Start Demo
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default StoreLayout;